import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { TableBaseStyle, EMCTrendStyle, ChartBaseStyle } from './EMCTrendStyle';
import { EMCAlarmInfoModel, EMCTrendGraphData } from './EMCTrend';
import ColorLineText from '../../atoms/Text/ColorLineText';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Label,
  CartesianGrid,
  ResponsiveContainer,
  ReferenceLine,
  Brush,
  Tooltip,
} from 'recharts';

import { GraphThemeLight } from '../../../Constant';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

type EMCTrendChartProps = {
  emcAlarmInfoModel: EMCAlarmInfoModel[];
  onChartSelectDataChangeEvent: (target: string) => void;
  chartSelectData: string;
  chartAlramBasePointData: string;
};

const EMCTrendChart: React.FC<EMCTrendChartProps> = (props) => {
  const tableStyle = TableBaseStyle();
  const emcTrendStyle = EMCTrendStyle();
  const chartStyle = ChartBaseStyle();
  const { t, i18n } = useTranslation();

  /**
   * グラフデータ加工処理
   * @param data
   * @returns
   */
  const convertGraphPoint = (data: EMCAlarmInfoModel[]) => {
    let ret: any = [];
    let obj1 = {};
    data.forEach((r) => {
      let tmp = { ['value_' + r.ItemNo]: 0 };
      obj1 = Object.assign(obj1, tmp);
    });
    data[0]?.TrendGraphDatas.map((r: EMCTrendGraphData) => {
      let tmp = { datetime: r.ColData };
      obj1 = Object.assign(obj1, tmp);
      //objectをコピーする
      const newObj = Object.assign({}, obj1);
      ret.push(newObj);
    });

    data.map((row, index) => {
      //console.debug(['row , index ', row, index]);
      row.TrendGraphDatas.map((row2, index2) => {
        ret[index2]['value_' + row.ItemNo] = row2.PercentValue;
      });
    });
    //console.debug(['convertGraphPoint', ret]);
    return ret;
  };

  /**
   * グラフクリックデータ取得
   * @param e
   */
  const chartControlClikAction = (e: any) => {
    //e: any CategoricalChartState
    if (e !== null && e.activeLabel !== null && e.activeLabel !== '') {
      props.onChartSelectDataChangeEvent(String(e.activeLabel));
    }
  };
  /**
   * Tooltip実装
   * active : true に設定すると、ツールチップが表示されます。false に設定すると、ツールチップは非表示になり、通常は内部で計算されます。
   * payload : ツールチップに表示されるコンテンツのソース データ。通常は内部で計算されます。
   * label : 現在アクティブなラベル値で、通常は内部で計算されます。
   * @param param0
   * @returns
   */

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active) {
      return (
        <div className={chartStyle.tooltip}>
          <div className="label">{dayjs(label).format('YY/MM/DD HH:mm')}</div>
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <ResponsiveContainer className={emcTrendStyle.chartContainer} width={'100%'}>
        <LineChart
          width={400}
          height={400}
          style={{ background: GraphThemeLight.BACK_COLOR }}
          data={convertGraphPoint(props.emcAlarmInfoModel)}
          margin={{
            top: 10,
            right: 30,
            left: 1,
            bottom: 0,
          }}
          onClick={(e) => {
            chartControlClikAction(e);
            console.debug(['LineChart- onClick', e]);
          }}
        >
          <CartesianGrid stroke={GraphThemeLight.GRID_COLOR} strokeDasharray="3 3" />
          <XAxis
            dataKey="datetime"
            type="category"
            allowDuplicatedCategory={false}
            stroke={GraphThemeLight.MEMORY_FONT_COLOR}
            tickFormatter={(r) => {
              return r === 0 || r === 'auto' || dayjs(r).isValid() === false ? '' : dayjs(r).format('MM/DD HH:mm');
            }}
            height={50}
            tick={{ dy: 8, fontSize: 11 }}
            padding={{ right: 0, left: 0 }}
          >
            <Label angle={0} position="insideBottomRight" style={{ textAnchor: 'middle', padding: 0 }}>
              {t('EMCTrendChart.時', '時')}
            </Label>
          </XAxis>
          <YAxis
            stroke={GraphThemeLight.GRID_COLOR}
            allowDataOverflow={true}
            domain={[0, 150]}
            ticks={[0, 50, 100, 150]}
            tickFormatter={(props) => props.toFixed(2)}
            width={100}
          >
            <Label angle={270} position="insideLeft" style={{ textAnchor: 'middle', padding: 0 }}>
              {'%'}
            </Label>
          </YAxis>
          <ReferenceLine y={100} stroke="red" strokeWidth={3} />
          <ReferenceLine x={props.chartSelectData} stroke="red" />
          <ReferenceLine x={props.chartAlramBasePointData} stroke="black" strokeWidth={3} />
          <Tooltip content={<CustomTooltip />} />
          {props.emcAlarmInfoModel?.map((row, index) => (
            <Line
              key={index}
              dataKey={'value_' + String(row.ItemNo)}
              stroke={row.ChartLineColor}
              strokeWidth={2}
              dot={false}
              name={row.ItemName}
              hide={!row.IsDisplay}
              isAnimationActive={false}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </>
  );
};

export default EMCTrendChart;
